<style scoped>
.excel-span {
  height: 24px;
  line-height: 24px;
  display: inline-block;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  background-color: #f4f4f5;
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
</style>
<template>
  <div>
    <el-dialog :visible.sync="visible" :title="title" append-to-body="append-to-body">
      <div :class="[tableData.length>0?'dialog-scroller':'']" style="display: flex;flex-direction: column;">
        <!--上传-->
        <div>
          <input id="matterFileInput" ref="excel-upload-input" class="excel-upload-input" type="file" multiple
              accept=".xlsx, .xls" @change="handleClick">
          <el-button :loading="loading" size="mini" type="primary" icon="el-icon-document-add"
              @click="exportModel">
            {{$t('xiazaimuban')}}
          </el-button>
          <el-button :loading="loading" size="mini" type="default" icon="el-icon-plus" @click="handleUpload">
            {{$t('piliangshangchuan')}}
          </el-button>
          <el-checkbox @change="changeAuto" v-model="checked" style="margin-left: 45px">{{$t('shifouzidongchaungjianwuliao')}}</el-checkbox>
        </div>
        <!--excel-->
        <div style="margin-top: 10px">
					<span v-for="(item, index) in excel" :key="index" class="excel-span" closable size="mini">
						<i class="el-icon-link"/>
						<span>{{item}}</span>
						<i style="margin-left: 5px" class="el-icon-close" @click="deleteExcel(item)"/>
					</span>
        </div>
        <!--表格-->
        <div ref="table" style="flex: 1;margin-top: 10px;">
<!--          v-loading="loading"-->
          <el-table :key="bomCheckKey"  stripe :max-height="tableHeight"
              :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize,pagination.currentPage * pagination.pageSize)"
              border size="mini"
              :header-cell-style="{background: '#F5F7FA',  color:'#606266','font-weight':'700', height:'48px', padding:'0px'}">
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop"
                :show-overflow-tooltip="true" :label="item.label" :width="item.width"
                :sortable="item.sortable">
              <template slot-scope="scope">
								<span>{{
                    scope.row[item.prop] === "" ? "-" : scope.row[item.prop]
                  }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
          <el-pagination v-if="tableData.length>0" style="display: flex; flex-direction: row-reverse"
              background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
              :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next"
              :total="tableData.length" @size-change="handleSizeChange"
              @current-change="handleCurrentChange"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button type="default" size="mini" @click="visible = false">{{$t('quxiao')}}</el-button>
			 <el-button :loading="plan_import_loading" type="primary" size="mini" @click="importData">{{$t('baocun')}}</el-button>
			</span>
    </el-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
  props: {
    schedulingShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      plan_import_loading: false,
      bomCheckKey:0,
      excel: [],
      checked:false,
      tableHeight: 0,
      tableData: [],
      tableColumn: [{
        label: this.$t('daorubaogao'),
        prop: 'result',
        with: 125
      }, {
        label: this.$t('jihuadanhao'),
        prop: 'no',
        with: 150
      },
        {
          label: this.$t('shebeimingcheng'),
          prop: 'equipmentName',
          with: 150
        },
        {
          label: this.$t('mojubianhao'),
          prop: 'mouldNo',
          with: 150
        },
        {
          label: this.$t('mujubianma'),
          prop: 'mouldCode',
          with: 150
        },
        {
          label: this.$t('mojumingcheng'),
          prop: 'mouldName',
          with: 150
        },
        {
          label: this.$t('moqiangshu'),
          prop: 'cavity',
          with: 150
        },
        {
          label: this.$t('biaozhunzhouqi(miao/mo)'),
          prop: 'standardCycle',
          with: 150
        },
        {
          label: this.$t('chanpinbianma'),
          prop: 'materialCode',
          with: 150
        },
        {
          label: this.$t('chanpinmingcheng'),
          prop: 'materialName',
          with: 150
        },
        {
          label: this.$t('bencipaichanshuliang'),
          prop: 'quantity',
          with: 150
        },
        {
          label: this.$t('jihuakaishishijian'),
          prop: 'startTimeText',
          with: 145

        },
        {
          label: this.$t('jihuawanchengshijian'),
          prop: 'endTimeText',
          with: 145
        },
        {
          label: this.$t('ERPgongdanhao'),
          prop: 'erpNo',
          with: 145
        },
        {
          label: this.$t('guishuchejian'),
          prop: 'orgName',
        },
        {
          label: this.$t('guishuzhujihuadanhao'),
          prop: 'parentNo',
          with: 150
        },
        {
          label: this.$t('gongdanshunxu'),
          prop: 'priority',
          with: 145
        },
        {
          label: this.$t('shifoujiafen'),
          prop: 'addPowderText',
          with: 145
        },
        {
          label: this.$t('beizhu'),
          prop: 'remark',
        },

      ],
      initialList:[],
      listLength:'',
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      visible: false,
      title: this.$t('daorupaichanfafang')
    }
  },
  watch: {
    schedulingShow: {
      handler(n) {
        this.visible = n
        if (n == true) {
          this.countTableHeight()
        }
        if (n == false) {
          this.currentPage = 1
          // this.checked = false
        }
      },
      immediate: false
    },
    // checked: {
    //   handler(n) {
    //     if(n==true||n==false ){
    //       this.getBatchImportScheduling()
    //     }
    //   },
    //   immediate: false,
    //   deep: true
    // },
    visible: {
      handler(n) {
        if (!n) {
          this.$emit('update:schedulingShow', false)
          this.tableData = []
          this.excel = []
          this.$refs['excel-upload-input'].value = null
        }
      },
      immediate: false
    }
  },
  mounted() {

  },
  methods: {
    changeAuto(e){
      console.log('eeeeeeeeeeeee',e)
      this.getBatchImportScheduling()
      this.bomCheckKey++
    },
    countTableHeight() {
      this.tableHeight = 0
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          this.tableHeight = this.$refs.table.offsetHeight - 10
        } else {
          this.tableHeight = 110
        }
      })
    },
    //深拷贝
    deepClone(data) {
      const type = this.judgeType(data);
      let obj;
      if (type === 'array') {
        obj = [];
      } else if (type === 'object') {
        obj = {};
      } else {
        // 不再具有下一层次
        return data;
      }
      if (type === 'array') {
        // eslint-disable-next-line
        for (let i = 0, len = data.length; i < len; i++) {
          obj.push(this.deepClone(data[i]));
        }
      } else if (type === 'object') {
        // 对原型上的方法也拷贝了....
        // eslint-disable-next-line
        for (const key in data) {
          obj[key] = this.deepClone(data[key]);
        }
      }
      return obj;
    },
    judgeType(obj) {
      // tostring会返回对应不同的标签的构造函数
      const toString = Object.prototype.toString;
      const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object',
      };
      if (obj instanceof Element) {
        return 'element';
      }
      return map[toString.call(obj)];
    },
    exportModel() {
      // return this.http.get('/web/customer/files/download?id=7').then(res => {
      // 	const baseUrl = res.data
      // 	if (res.data) {
      // 		window.open(baseUrl)
      // 	}
      // }).catch(error => {
      // 	this.$message.error(error)
      // })
      window.open(
          (process.env.NODE_ENV === "development" ? global.URL_DEV_API_BASE_DOMAIN :
              (process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_API_BASE_DOMAIN : global.URL_PROD_API_BASE_DOMAIN)) +
          "/web/customer/files/viewFileByFileId/shengchanjihuapaichanfafangdaoruuban"
      );

    },
    formatDate(serial, format) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var fractional_day = serial - Math.floor(serial) + 0.0000001;
      var total_seconds = Math.floor(86400 * fractional_day);
      var seconds = total_seconds % 60;
      total_seconds -= seconds;
      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      var daytime = new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes,
          seconds);
      var returnDate = date_info.getFullYear();
      returnDate += format + (date_info.getMonth() < 9 ? '0' + (date_info.getMonth() + 1) : (date_info
          .getMonth() + 1));
      returnDate += format + (date_info.getDate() < 10 ? '0' + date_info.getDate() : date_info.getDate());
      returnDate += " " + (daytime.getHours() < 10 ? '0' + daytime.getHours() : daytime.getHours());
      returnDate += ":" + (daytime.getMinutes() < 10 ? '0' + daytime.getMinutes() : daytime.getMinutes());
      return returnDate;
    },
    importData() {
      const data = this.deepClone([...this.tableData])
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'))
        return;
      }
      this.plan_import_loading = true;
      for (let i = 0; i < data.length; i++) {
        if (data[i]['addPowderText'] == this.$t('shi')) {
          data[i]['addPowder'] = true;
        } else if (data[i]['addPowderText'] == this.$t('fou')) {
          data[i]['addPowder'] = false;
        }
        data[i]['startTimeText']= this.dateFormat(data[i]['startTimeText'])
        data[i]['endTimeText'] = this.dateFormat( data[i]['endTimeText'])
        data[i]['startTime'] = new Date(data[i]['startTimeText']).getTime()
        data[i]['endTime'] = new Date(data[i]['endTimeText']).getTime()

        delete data[i]['excel']
      }

      if (this.listLength == null  || this.listLength.length == 0) {
        let params = {
          autoCreate: this.checked,
          onlyValidate: false
        }
        return this.http.post('/custom/production/plan/batchImportScheduling?'+ this.qs.stringify(params), data).then(response => {
          this.utils.successMessage(this.$t(response.msg));
          this.schedulingShow = false;
          // 刷新主页面列表(参数要与被调用得页面$on()中名称对应)
          this.utils.event_hub.$emit('ORDER_MANAGEMENT_CUSTOMIZED_REFRESH');
        }).catch((error) => {
          this.utils.errorMessage(this.$t(error))
        }).finally(() => {
            this.plan_import_loading = false;
        })

      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
    dateFormat(time) {
      const t = new Date(time)
      // 日期格式
      const format = 'Y-m-d h:i:s'
      let year = t.getFullYear()
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1
      let day = t.getDate()
      let hours = t.getHours()
      let minutes = t.getMinutes()
      let seconds = t.getSeconds()
      month = month > 9 ? month : `0${month}`
      day = day > 9 ? day : `0${day}`
      hours = hours > 9 ? hours : `0${hours}`
      minutes = minutes > 9 ? minutes : `0${minutes}`
      seconds = seconds > 9 ? seconds : `0${seconds}`
      const hash = {
        'Y': year,
        'm': month,
        'd': day,
        'h': hours,
        'i': minutes,
        's': seconds
      }
      return format.replace(/\w/g, o => {
        return hash[o]
      })
    },
    /**
     * 数据解析
     * @param header
     * @param results
     * @param name
     */
    generateData({
                   header,
                   results,
                   name
                 }) {
      const data = []
      if (results.length > 0) {
        for (let i = 0; i < results.length; i++) {
          const item = {
            excel: name
          }
          for (let j = 0; j < this.tableColumn.length; j++) {
            if (results[i][this.tableColumn[j]['label']]) {
              this.$set(
                  item,
                  this.tableColumn[j]['prop'],
                  results[i][this.tableColumn[j]['label']]
              )
            }
          }
          item['startTimeText'] = this.formatDate(item['startTimeText'], '/')
          item['endTimeText'] = this.formatDate(item['endTimeText'], '/')
          console.log('ddddd', item)
          data.push(item)
        }
      }
      this.tableData = this.tableData.concat(data)
      // for (let i = 0; i < this.tableData.length; i++) {
      // 	this.$set(this.tableData[i], 'rid', i + 1)
      // }
      this.excel.push(name)

      this.countTableHeight()


    },
    /**
     * 显示上传弹框
     */
    handleUpload() {
      this.$refs['excel-upload-input'].click()
    },
    /**
     * 点击上传
     * @param e
     * @returns {Promise<void>}
     */
    async handleClick(e) {

      const files = e.target.files
      for (let i = 0; i < files.length; i++) {
        this.beforeUpload(files[i])
      }
      setTimeout(() => {
        this.getBatchImportScheduling()
        this.bomCheckKey++;
      }, 800)


    },
   async getBatchImportScheduling(){
     // this.loading = true
      document.getElementById('matterFileInput').value = ''

      let data = [...this.tableData]
      // for (let i = 0; i < data.length; i++) {
      //   delete data[i]['excel']
      // }
      for (let i = 0; i < data.length; i++) {
        if (data[i]['addPowderText'] == this.$t('shi')) {
          data[i]['addPowder'] = true;
        } else if (data[i]['addPowderText'] == this.$t('fou')) {
          data[i]['addPowder'] = false;
        }
        data[i]['startTimeText']= this.dateFormat(data[i]['startTimeText'])
        data[i]['endTimeText'] = this.dateFormat( data[i]['endTimeText'])
        data[i]['startTime'] = new Date(data[i]['startTimeText']).getTime()
        data[i]['endTime'] = new Date(data[i]['endTimeText']).getTime()
        // data[i]['startTimeText']= this.dateFormat(data[i]['startTimeText'])
        // data[i]['endTimeText'] = this.dateFormat( data[i]['startTimeText'])

        delete data[i]['excel']
      }
      this.initialList = data
      let params = {
        autoCreate: this.checked,
        onlyValidate: true
      }
    await this.http.post('/custom/production/plan/batchImportScheduling?'+ this.qs.stringify(params), data).then(response => {
        console.log('response', response.data)
      for(const j in this.tableData){
        this.$set(this.tableData[j], 'result', '')
      }
        this.listLength = response.data.validateItems
        if (response.data.validateItems && response.data.validateItems.length > 0) {
          const list = response.data.validateItems
          for (let i = 0; i < list.length; i++) {
            this.$set(this.tableData[Number(list[i]['index'])], 'result', list[i]['items'].join(','))
          }
        }
      // this.loading = false
      }).catch((error) => {
        this.utils.errorMessage(this.$t(error))
      })
    },
    /**
     * 上传前
     * @param rawFile
     * @returns {boolean}
     */
    beforeUpload(rawFile) {
      if (this.excel.length < 2) {
        //this.$refs['excel-upload-input'].value = null
      }
      if (!this.isExcel(rawFile)) {
        this.$message.error(this.$t('zhizhichi') + '.xlxs,xls,csv' + this.$t('geshiwenjian'));
        return false
      }
      if (this.excel.length > 2) {
        this.$message.error(this.$t('zuidazhichi') + '3' + this.$t('geexcelwenjian'));
        return false
      }
      if (this.excel.includes(rawFile.name)) {
        this.$message.error(rawFile.name + this.$t('wenjianyicunzai'));
        return false
      }
      this.readerData(rawFile)
    },

    /**
     * 解析excel
     * @param rawFile
     */
    readerData(rawFile) {
      this.loading = true
      const reader = new FileReader()
      reader.onload = (e) => {
        const name = rawFile.name
        const data = e.target.result
        const workbook = XLSX.read(data, {
          type: 'array'
        })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const header = this.getHeaderRow(worksheet)
        const results = XLSX.utils.sheet_to_json(worksheet)
        this.generateData({
          header,
          results,
          name
        })
        this.loading = false
      }
      reader.readAsArrayBuffer(rawFile)
    },
    /**
     * 获取excel头部
     * @param sheet
     * @returns {[]}
     */
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[XLSX.utils.encode_cell({
          c: C,
          r: R
        })]
        let hdr = 'UNKNOWN ' + C
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    /**
     * 判断是否为excel文件
     * @param file
     * @returns {boolean}
     */
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
    },
    /**
     * 刪除excel
     * @param name
     */
    deleteExcel(name) {
      this.excel = this.excel.filter((item) => {
        return item !== name
      })
      this.tableData = this.tableData.filter((item) => {
        return item.excel !== name
      })
      console.log("excel:", this.excel)
      console.log('tableData:', this.tableData)
      console.log('tableColumn', this.tableColumn)
    }
  }
}
</script>

<style scoped>
.excel-upload-input {
  display: none;
  z-index: -9999;
}

.drop {
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
